import { Validator } from 'vee-validate'

export default {
  createValidator (context) {
    // console.log('Validation.createValidator')
    const validator = new Validator()
    validator.orgrec = {}
    return validator
  },
  addValidation (validator, rec, fieldName, alias, rules) {
    // console.log('Validation.addValidation', fieldName, rules)
    validator.attach(fieldName, rules, { alias: alias })
    // validator.orgrec[fieldName] = rec[fieldName]
  },
  setOriginalRec (validator, rec) {
    // console.log('Validation.setOriginalRec', rec)
    validator.orgrec = {}
    Object.assign(validator.orgrec, rec)
  },
  validateValue (validator, fieldName, value) {
    // console.log('Validation.validateValue', fieldName, value)
    return validator.validate(fieldName, value)
  },
  validateAll (validator, rec, okFnc, failFnc) {
    // console.log('Validation.validateAll', validator, rec)
    validator.validateAll(rec).then(result => {
      // console.log('validateAll done', result)
      if (result) {
        // console.log('validateAll Ok!')
        if (okFnc) {
          okFnc(this.getChangedFields(validator, rec))
        }
      } else {
        console.log('Correct them errors!', validator)
        if (failFnc) {
          failFnc(validator)
        }
      }
    })
  },
  getChangedFields (validator, rec) {
    // console.log('getChangedFields', rec, validator.orgrec)
    let result = {}
    if (rec.id) result.id = rec.id
    for (const k in rec) {
      // const v = fields[k]
      const cur = rec[k]
      const prev = validator.orgrec[k] === undefined ? '' : validator.orgrec[k]
      // console.log(k, cur, prev)
      if (cur !== prev) {
        // console.log(k, cur, prev)
        result[k] = cur
      }
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/validation/index.js